import { useState } from 'react';
import { Link } from 'react-router-dom';
import { features } from '@/mocks/data';

export default function Features() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择蜜桃传媒
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            我们用心打造每一个细节，只为带给你极致的观影体验
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {features.map((f) => (
            <div key={f.id} className="text-center p-6 rounded-lg bg-background-100/70 transition-all duration-300 hover:bg-background-100">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100">
                <i className={`${f.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2 whitespace-nowrap">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}